import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import * as api from '@/api/flyerDocs';
import type { FlyerDocumentInput } from '@/types/flyerDoc';

export const FLYER_DOCS_KEY = ['flyer-docs'] as const;
export const FLYER_DOC_KEY = (id: string) => ['flyer-doc', id] as const;

export function useFlyerDocs() {
  return useQuery({ queryKey: FLYER_DOCS_KEY, queryFn: api.listFlyerDocs });
}
export function useFlyerDoc(id: string | null) {
  return useQuery({ queryKey: FLYER_DOC_KEY(id ?? 'none'), queryFn: () => api.getFlyerDoc(id!), enabled: !!id });
}
export function useCreateFlyerDoc() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (b: FlyerDocumentInput) => api.createFlyerDoc(b),
    onSuccess: () => qc.invalidateQueries({ queryKey: FLYER_DOCS_KEY }),
  });
}
export function useUpdateFlyerDoc() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, b }: { id: string; b: FlyerDocumentInput }) => api.updateFlyerDoc(id, b),
    onSuccess: (_d, v) => {
      qc.invalidateQueries({ queryKey: FLYER_DOCS_KEY });
      qc.invalidateQueries({ queryKey: FLYER_DOC_KEY(v.id) });
    },
  });
}
export function useDeleteFlyerDoc() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => api.deleteFlyerDoc(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: FLYER_DOCS_KEY }),
  });
}
